module.exports = __webpack_public_path__ + "static/phabricator-448682776cf18825ccf5e96b752fbf3f.png";